<template>
    <div class="mt-2 mb-4">
        <SearchInput @handleInput="(value) => (userInput = value)" />
        <GroupMembersContainer :groupMembers="groupMembers" @handleCancel="handleCancel" />
    </div>

    <ContactList
        @handleContactClick="handleAddContactToGroup"
        :isLoading="loadingState.startChat || loading.adding_to_group"
        :disabledContacts="groupMembers"
        :searchQuery="userInput"
    />
</template>

<script setup>
import SearchInput from "../../SearchInput.vue";
import ContactList from "./ContactList.vue";
import GroupMembersContainer from "./GroupMembersContainer.vue";
import { useChatStore } from "@/stores/chatStore";
import { groupMembers } from "./globalStates";
import { ref } from "vue";
import { blue } from "tailwindcss/colors";

// [info]: states
const loading = ref({
    adding_to_group: false,
});
const userInput = ref("");

// [info]: composable
const { loadingState, getMemberDetailFromNode } = useChatStore();

// [info]: methods

const handleAddContactToGroup = async (contact) => {
    try {
        loading.value.adding_to_group = true;
        const contactDetail = await getMemberDetailFromNode(contact);
        if (groupMembers.value.some((mem) => mem.id === contact.id)) return;
        groupMembers.value.push({
            ...contact,
            _id: contactDetail._id,
            text: contactDetail.email,
            icon: contactDetail.pic && contactDetail.pic !== "" ? contactDetail.pic : null,
            color: blue[500],
        });
        const container = document.getElementById("groupMemberContainer");
        if (container) {
            requestAnimationFrame(() => {
                container.scrollTo({
                    left: container.scrollWidth,
                    behavior: "smooth",
                });
            });
        }
    } catch (e) {
        console.error("[err]: at adding member to group", e);
    } finally {
        loading.value.adding_to_group = false;
    }
};

const handleCancel = (state, target) => {
    if (state === "cancel") {
        groupMembers.value = groupMembers.value.filter((contact) => contact.id !== target.id);
    }
};
</script>
